import * as React from 'react';
import { CalendarReadingPane, getCalendarEvent } from 'owa-publishedcalendar-eventdetails';
import { getDocument, getFirstFocusable } from '@fluentui/react/lib/Utilities';
import { getSurfaceStore } from '../store/publishedCalendarSurfaceStore';
import { Modal } from '@fluentui/react/lib/Modal';
import { observer } from 'mobx-react-lite';
import { updateModuleCommand } from 'owa-publishedcalendar-settings';

let styles = require('./CalendarReadingPanePanel.scss');

/**
 * Calendar reading pane panel to show details of a calendar item
 */
export default observer(function CalendarReadingPanePanel() {
    let currentDoc: Document = getDocument();
    let focusElementOnNavigation = currentDoc
        ? (currentDoc.getElementById(getSurfaceStore().selectedItemCSSSelector) as HTMLElement)
        : null;

    const calendarEvent = getCalendarEvent();

    return calendarEvent ? (
        <Modal
            isOpen={true}
            onDismiss={onPanelDismiss}
            isBlocking={false}
            elementToFocusOnDismiss={getFirstFocusable(
                focusElementOnNavigation,
                focusElementOnNavigation,
                true /*includeElementsInFocusZones*/
            )}
            containerClassName={styles.dialog}>
            <CalendarReadingPane item={calendarEvent} dimissReadingPane={onPanelDismiss} />
        </Modal>
    ) : null;
});

/**
 * Function that gets called when the panel is dismissed
 */
function onPanelDismiss() {
    updateModuleCommand(null);
}
